export default class Ingredient {
    name: string;
    description: string;
    img: string;
  image_alt: string;
    readMore: boolean;

    constructor(ingredient: any) {
        this.name = ingredient.name;
        this.description = ingredient.ingredientsDescription;
        this.img = ingredient.img;
        this.readMore = ingredient.readmore;
        this.image_alt = ingredient.image_alt;
    }
}
